import { api, catchErrorHandler } from "utils/api";

export const qnaList = async ({
  startDt,
  endDt,
  qnaStatus,
  page,
  seqPartner,
  seqPartnerBranch,
  seqPartnerCoach,
  searchTerm,
}) => {
  try {
    const tabObj = {
      0: null,
      1: "N",
      2: "Y",
    };
    const { data } = await api.post(`/qna/list`, {
      startDate: startDt,
      endDate: endDt,
      answerCompleteYn: tabObj[qnaStatus],
      seqPartner: seqPartner,
      seqPartnerBranch: seqPartnerBranch,
      criteria: {
        page: page,
        pageSize: 20,
      },
      seqPartnerCoach,
      keyword: searchTerm,
    });
    return data;
  } catch (error) {
    throw "";
  }
};

export const getQnaDetail = async (params) => {
  try {
    const { data } = await api.post(`/qna/comment/list`, params);
    return data;
  } catch (error) {
    return catchErrorHandler(error, "getQnaDetail", false);
  }
};

export const answerRegister = async ({
  uploadId,
  seqPartnerCoach,
  commentContent,
}) => {
  try {
    const { status } = await api.put(`/qna/comment`, {
      uploadId,
      seqPartnerCoach,
      commentContent,
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "answerRegister");
  }
};

export const answerEdit = async ({
  seqPartner,
  seqPartnerBranch,
  uploadId,
  commentId,
  commentContent,
}) => {
  try {
    const { status } = await api.patch(`/qna/comment`, {
      seqPartner,
      seqPartnerBranch,
      uploadId,
      commentId,
      commentContent,
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "answerEdit");
  }
};

export const answerDelete = async ({
  seqPartner,
  seqPartnerBranch,
  uploadId,
  commentId,
}) => {
  try {
    const { status } = await api.delete(`/qna/comment`, {
      data: {
        seqPartner,
        seqPartnerBranch,
        uploadId,
        commentId,
      },
    });

    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "answerDelete");
  }
};
